<mat-toolbar class="topbar p__custom-topbar-spaceBetween">
  <button mat-icon-button (click)="toggleMobileNav.emit()" *ngIf="!showToggle">
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>

  <!-- <div>
    <p class="txt__custom-time">
      {{ currentTime }}
    </p>
    <p class="txt__custom-thungaythang">
      {{ currentDay }}
    </p>
  </div> -->
  <span style="flex: 1 1 auto;"></span>
  <div class="p__customNoticeAndUser">
    <!-- <select (change)="ChangeLang($event)" name="" id="" class="selectbasic" style="width: 100px;">
      <option [selected]="lang==='vi'" value="vi">Việt Nam</option>
      <option [selected]="lang==='en'" value="en">English</option>
      <option [selected]="lang==='fr'" value="fr">French</option>
      <option [selected]="lang==='cn'" value="cn">Chinese</option>
    </select> -->
    <!-- <button mat-icon-button aria-label="Notifications">
      <i-tabler class="d-flex" name="bell" matBadge="1" matBadgeColor="primary"></i-tabler>
    </button> -->
    <button type="button" class="btn Btn__custom-add2 btn__cusText btnres" style="margin-top: 0px !important;" (click)="togglePhimTatDialog()">
      Phím tắt
      <small class="shortcut-hint">`</small>
    </button>
    <button mat-icon-button [matMenuTriggerFor]="notificationMenu" aria-label="Notifications">
      <i-tabler class="d-flex" name="bell" matBadge="{{unreadCount}}" matBadgeColor="primary"></i-tabler>
    </button>
  
    <!-- <span class="flex-1-auto"></span> -->
    <div class="p__customAvatarAndHello" [matMenuTriggerFor]="profilemenu">
      <button mat-icon-button aria-label="Notifications">
        <!-- <img src="https://cdn-icons-png.flaticon.com/512/9187/9187604.png" class="rounded-circle object-cover" width="35" /> -->
        <!-- <img src="../../../../assets/images/svgs/Rectangle5.svg" class="rounded-circle object-cover" width="40" />  -->
        <img [src]="getImageUrl(userInfo.Avata)" class="rounded-circle object-cover" width="40" />
      </button>
      <div class="UserInfo__custom">
        <!-- <p class="txt__customHelloUser">{{'HEADER.XINCHAO'|translate}}</p> -->
        <p class="info-user txt__customInfoUser">{{userInfo.FullName}}</p>
      </div>
    </div>
    
  </div>

  
  <mat-menu #profilemenu="matMenu" class="cardWithShadow" class="card-info">
    <!-- <h5>Hồ sơ cá nhân</h5> -->
    <!-- <div class="d-flex align-items-center gap-20 mt-4 mb-3">
      <img src="https://cdn-icons-png.flaticon.com/512/9187/9187604.png" class="rounded-circle object-cover"
        width="95" />
      <div>
        <h6 class="info-user">{{userInfo.FullName}}</h6>
        <h6 class="info-user">{{userInfo.FullName}}</h6>
        <h6 class="info-user">{{userInfo.Email + '@gmail.com'}}</h6>
      </div>
    </div>
    <hr /> -->
    <button mat-menu-item [routerLink]="['/user/user-info']">
      <mat-icon class="d-flex align-items-center"><i-tabler name="user-filled"
          class="icon-18 d-flex"></i-tabler></mat-icon>{{'MENU.INFO_ACCOUNT'|translate}}
    </button>
    <button mat-menu-item (click)="openDialog()">
      <mat-icon class="d-flex align-items-center"><i-tabler name="lock" class="icon-18 d-flex"></i-tabler></mat-icon>{{'MENU.CHANGE_PASSWORD'|translate}}
    </button>
    <button mat-menu-item [routerLink]="['/guide']">
      <mat-icon class="d-flex align-items-center"><i-tabler name="file-description"
          class="icon-18 d-flex"></i-tabler></mat-icon>{{'MENU.HDSD'|translate}}
    </button>
    <button mat-menu-item [routerLink]="['/guide']">
      <mat-icon class="d-flex align-items-center"><i-tabler name="file-description"
          class="icon-18 d-flex"></i-tabler></mat-icon>{{'MENU.UDSCAn'|translate}}
    </button>
    <button mat-menu-item > 
      <mat-icon class="d-flex align-items-center"><i-tabler name="user-question"
          class="icon-18 d-flex"></i-tabler></mat-icon>{{'MENU.HOIDAP'|translate}}
    </button>

    <div class="p-x-12 m-t-12">
      <a 
        [routerLink]="['/login']"
        mat-stroked-button color="primary" 
        class="w-100 d-flex align-items-center justify-content-center gap-3 btn-customlogout"
        (click)="logout()">
        {{'MENU.LOGOUT'|translate}} 
          <mat-icon class="d-flex align-items-center"> <i-tabler name="logout"
            class="icon-18 d-flex"></i-tabler></mat-icon>
      </a>
       
    </div>
  </mat-menu>

  <mat-menu #notificationMenu="matMenu" class="notification-menu">
    <div class="notification-header p-3 d-flex justify-content-between align-items-center">
      <h6 class="m-0">Thông báo</h6>
      <button mat-button color="primary" (click)="markAllAsRead()">Đánh dấu tất cả đã đọc</button>
    </div>
    <mat-divider></mat-divider>
    <div class="notification-list" style="max-height: 400px; overflow-y: auto;">
      <div class="notification-item p-3" *ngFor="let notification of notifications" 
           [class.unread]="!notification.IsRead"
           (click)="markAsRead(notification)">
        <div class="d-flex gap-3">
          <div class="notification-icon">
            <i-tabler name="bell" class="text-primary"></i-tabler>
          </div>
          <div class="notification-content">
            <h6 class="notification-title mb-1">{{notification.Title}}</h6>
            <p class="notification-text mb-1">{{notification.Content}}</p>
            <small class="text-muted">{{notification.CreatedAt | date:'dd/MM/yyyy HH:mm:ss'}}</small>
          </div>
        </div>
      </div>
      <div *ngIf="notifications.length === 0" class="p-3 text-center text-muted">
        Không có thông báo nào
      </div>
    </div>
    <mat-divider></mat-divider>
    <!-- <div class="p-2 text-center">
      <button mat-button color="primary" (click)="viewAllNotifications()">Xem tất cả thông báo</button>
    </div> -->
  </mat-menu>
</mat-toolbar>